import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const useAuth = () => {
    const authContext = useContext(AuthContext);
    if (authContext === undefined)
        throw new Error(
            "useAuthContext should be used within a AuthContextProvider "
        );

    return authContext;
};